import apiProxy from "@shared/utils/api-proxy.ts";
import { UsageExplorerFeatureFlagsResponse } from "@shared/types/localTypes/usage-explorer.ts";

export default async ({ subscription }: { subscription: number }) => {
  const response: UsageExplorerFeatureFlagsResponse | null = await apiProxy.get(
    "usage-explorer/feature-flags",
    {
      params: { subscription },
    },
  );

  if (!response) {
    throw new Error("Got no response from server");
  }
  return response;
};
